var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['wrapper', { selected: _setup.props.selected }],on:{"click":function($event){return _setup.emit('click')}}},[_c('h4',{staticClass:"title"},[_vm._v(" "+_vm._s(_setup.props.title)+" "),_c(_setup.CaretRight)],1),_c('div',{staticClass:"description-wrapper"},[_vm._t("description")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }